import LinkIcon from "@mui/icons-material/Link"
import LinkOffIcon from "@mui/icons-material/LinkOff"
import { IconButton, Tooltip } from "@mui/material"
import { t } from "i18next"
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux"
import { setLockAspectRationAsync } from "../../../../store/slices/editor.slice"
import { LOCKED_COLOR } from "../../../common/PropertyTools/DimensionsPair"

export const LockAspectRatio = ({ size }: { size?: "small" | "medium" }) => {
    const dispatch = useAppDispatch()
    const lockAspectRation = useAppSelector((state) => state.editor.value.settings.lockAspectRatio)

    const handleLockAspectRation = () => {
        dispatch(setLockAspectRationAsync(lockAspectRation))
    }

    return (
        <Tooltip
            title={
                lockAspectRation
                    ? t("editor:size&positionSettings.lockAspectRatioTooltip.unlock")
                    : t("editor:size&positionSettings.lockAspectRatioTooltip.lock")
            }
        >
            <IconButton
                // locked is highlighted, matching the link drawn between width and height
                color="secondary"
                sx={lockAspectRation ? { color: LOCKED_COLOR } : undefined}
                size={size}
                onClick={handleLockAspectRation}
                aria-pressed={lockAspectRation}
            >
                {lockAspectRation ? (
                    <LinkIcon fontSize={size} style={{ transform: "rotate(90deg)" }} />
                ) : (
                    <LinkOffIcon fontSize={size} style={{ transform: "rotate(90deg)" }} />
                )}
            </IconButton>
        </Tooltip>
    )
}
